import React from "react";
import { useLocalStorage } from "../../Hooks/useLocalStorage";

export const NotificationContext = React.createContext({
  activeNotificationTab: {},
  setActiveNotificationTab: () => {},
  activeNotificationNav: {},
  setNotificationNavResetTab: () => {},
  filterNotificationBy: {},
  localActiveNotificationNav: {},
  setLocalActiveNotificationNav: () => {},
  localActiveNotificationTab: {},
  setLocalActiveNotificationTab: () => {},
  checkedNotifications: [],
  setCheckedNotifications: () => {},
});

export const NotificationProvider = (props) => {
  const [localActiveNotificationTab, setLocalActiveNotificationTab] = useLocalStorage("localActiveNotificationTab", {
    ui_name: "Active",
    machine_name: "Active",
  });
  const [localActiveNotificationNav, setLocalActiveNotificationNav] = useLocalStorage("localActiveNotificationNav", {
    ui_name: "Active",
    machine_name: "Active",
  });
  const [activeNotificationTab, setActiveNotificationTab] = React.useState(localActiveNotificationTab);
  const [activeNotificationNav, setActiveNotificationNav] = React.useState(localActiveNotificationNav);
  const [filterNotificationBy, setFilterNotificationBy] = React.useState({});
  const [checkedNotifications, setCheckedNotifications] = React.useState([]);
  const setNotificationNavResetTab = (nav) => {
    setActiveNotificationTab({ ui_name: "Active", machine_name: "Active" });
    setActiveNotificationNav(nav);
    setLocalActiveNotificationNav(nav);
    setFilterNotificationBy({});
    setCheckedNotifications([]);
  };
  return (
    <NotificationContext.Provider
      value={{
        activeNotificationTab,
        setActiveNotificationTab,
        activeNotificationNav,
        setNotificationNavResetTab,
        filterNotificationBy,
        setFilterNotificationBy,
        setLocalActiveNotificationTab,
        setLocalActiveNotificationNav,
        checkedNotifications,
        setCheckedNotifications,
      }}
    >
      {props.children}
    </NotificationContext.Provider>
  );
};
